import { scrollWithOffset } from "./helpers";

function handleOpacity(child, close = false) {
  const osaajat = document.querySelectorAll(".osaajat-col");
  osaajat.forEach((el) => {
    if (close) {
      el.classList.remove("not-active");
      return;
    }
    if (!el.contains(child)) {
      el.classList.add("not-active");
    } else {
      el.classList.remove("not-active");
    }
  });
}

function handleOsaajaOpen(e) {
  e.preventDefault();

  const target = e.currentTarget;
  const id = target.getAttribute("data-block-id");
  const idx = target.getAttribute("data-index");
  const close = target.getAttribute("data-close") === "";

  // Early return if some of the data is missing.
  if (!id || !idx) return;

  document.querySelectorAll(".osaajat-info").forEach((el) => {
    el.classList.add("hidden");
    el.classList.remove("animate-in");
  });

  const child = document.querySelector(`#osaajat-info-${id}-${idx}`);
  const parent = document.querySelector(`#osaajat-${id}-${idx}`);
  if (!close && child) {
    child.classList.remove("hidden");
    setTimeout(() => {
      child.classList.add("animate-in");
    }, 20);
    setTimeout(() => {
      scrollWithOffset(child);
    }, 420);
    handleOpacity(parent);
  } else if (close && parent) {
    scrollWithOffset(parent);
    handleOpacity(parent, true);
  }
}

function setupListeners(el) {
  el.querySelectorAll("[data-toggle]").forEach((toggle) =>
    toggle.addEventListener("click", handleOsaajaOpen)
  );
}

export const setupPersonCards = () => {
  const blocks = document.querySelectorAll("[data-osaajat]");
  blocks.forEach((el) => {
    setupListeners(el);
  });
};
